import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadContactBlockData from '../../../Models/Content/AbroadContactBlockData';
import React, {useEffect} from 'react';
import {Col, Row, Container} from 'reactstrap';
import {gaEvent} from '../../../utilities/analytics/tracking';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import gaParams from '../../../utilities/analytics/constants';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';

const AbroadContactBlock = (props) => {
  const isGolan = getMarketCode() == DomainMarketCode.GOLAN;
  let isBusiness = false;
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';

  useEffect(() => {
    if (props.activeLobbyTab == 'businessAccount') isBusiness = true;

    window.addEventListener('scroll', trackScrolling);

    function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, []);

  useEffect(() => {
    if (props.activeLobbyTab == 'businessAccount') isBusiness = true;
    else isBusiness = false;

    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [props.activeLobbyTab, props.abroadPackagesList]);

  const gaReport = () => {
    if (isMobile) {
      if (isBusiness) {
        if (props.otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_CONTACTSERVICES_CLICK.category,
            gaParams.SEPARATED_CONTACTSERVICES_CLICK.eventType,
            props.abroadPackagesList ? search : lobby,
          );
        }
        {
          gaEvent('hul_sale_business', 'click_34', props.abroadPackagesList ? search : lobby);
        }
      } else {
        gaEvent('hul_sale_private', 'click_22', props.abroadPackagesList ? search : lobby);
      }
    }
  };

  function trackScrolling() {
    const wrappedElement = document.getElementById('abroad-contact');

    if (isBottom(wrappedElement)) {
      if (props.activeLobbyTab == 'businessAccount') {
        if (props.otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_CONTACTSERVICES_SHOW.category,
            gaParams.SEPARATED_CONTACTSERVICES_SHOW.eventType,
            props.abroadPackagesList ? search : lobby,
          );
        }
        {
          gaEvent('hul_sale_business', 'visibility_21', props.abroadPackagesList ? search : lobby);
        }
      } else {
        if (!props.businessIndividual) {
          gaEvent('hul_sale_private', 'visibility_13', props.abroadPackagesList ? search : lobby);
        }
      }

      window.removeEventListener('scroll', trackScrolling);
    }
  }

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }
  const contactWhatsApp = isGolan ? '0587778888' : '0524999123';

  return (
    <div id='abroad-contact' className='abroad-contact'>
      <Container style={{maxWidth: '1620px'}}>
        <div className='bg-main'>
          <div className='text-box'>
            <h2>זמינים עבורכם</h2>
            <h2>
              <strong> בכל שעה מהארץ ומחו"ל</strong>
            </h2>
            <div className='number-style'>
              <h3>
                {' '}
                <strong>בוואטסאפ</strong> &nbsp;
              </h3>
              <h2 className='bottom-line'>{window.Config.whatsAppSelfCare}</h2>
            </div>
            <h3>
              או <strong> בשיחת חינם </strong>
            </h3>
            <h2 className='bottom-line'>{Config.numberCallCenterAbroad.replace('+', '').concat('+')}</h2>
          </div>
        </div>

        <div className='bg-main-small'>
          <div className='separator'></div>
          <div className='text-box-small'>
            <h2>זמינים עבורכם</h2>
            <h2>
              <strong> בכל שעה מהארץ ומחו"ל</strong>
            </h2>
            <div className='number-style'>
              <h3>
                {' '}
                <strong>בוואטסאפ</strong> &nbsp;
              </h3>
              <h2 className='bottom-line'>{window.Config.whatsAppSelfCare}</h2>
            </div>
            <h3>
              או <strong> בשיחת חינם </strong>
            </h3>
            <h2 className='bottom-line' onClick={gaReport}>
              <a href={`tel:${Config.numberCallCenterAbroad.replace('-', '')}`} className={`bottom-line`}>
                {Config.numberCallCenterAbroad.replace('+', '').concat('+')}
              </a>
            </h2>
          </div>
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    abroadPackagesList: state.cellcomAbroad.abroadPackagesList,
    otpData: state.cellcomAbroad.otpData,
    businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
  };
};

export default connect(mapStateToProps)(AbroadContactBlock);
